import React from "react";

export default function Textblock({ section }) {
  const { title, paragraph1 } = section?.content || {};

  return (
    <div className="container pb-6 pb-md-8">
      <div className="row">
        <div className="col-12">
          <h2>{title}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <article>
            <p className="mr-prewrap">{paragraph1}</p>
          </article>
        </div>
      </div>
    </div>
  );
}
